<mat-toolbar color="primary" class="mat-elevation-z4">
  <button type="button" mat-icon-button class="menu" (click)="toggleMenu.emit()">
    <mat-icon>menu</mat-icon>
  </button>

  <div class="animation-container">
    <div class="title" ngClass.xs="xs" @titleAnimation fxHide.gt-xs>CrossoverPlus</div>
    <span class="env-badge" *ngIf="!isProduction">{{ envstring }}</span>

    <div class="subtitle" @subtitleAnimation *ngIf="title.showSubtitle$ | async"><span fxHide.xs> - </span>{{ title.subtitle$ | async }}</div>
  </div>

  <span
    class="version-badge"
    *ngIf="appVersion()"
    [matTooltip]="getTooltipText()"
    matTooltipClass="version-tooltip">
    v{{ appVersion() }}
  </span>

  <app-usermenu class="usermenu"></app-usermenu>
</mat-toolbar>
